module.exports = __webpack_public_path__ + "img/preloader.68d20379.gif";